<template>
    <div class="margin-top-m">
        <r-badge close @close="removeCustomerTag(tag)" type="tag" class="inline-xs no-box-shadow margin-bottom-xs" v-for="(tag,index) in tags" :key="index" v-fs-block>
            <v-icon icon="tag"/>
            {{tag}}
        </r-badge>
        <span @click="openTagsModal" class="cursor-pointer">
            <r-badge type="tag" class="inline-xs no-box-shadow margin-bottom-xs">
                <v-icon icon="plus"/> Add tag...
            </r-badge>
        </span>
        <tags-manager-modal
            v-if="showTagsModal"
            :type="type"
            :disabled="isLoading"
            :loading="isLoading"
            :values-list="tags"
            :async-get-init-value="asyncGetInitValue"
            :async-find="asyncFind"
            :async-config="asyncConfig"
            @update="updateCustomerTag"
            @close="showTagsModal = false"/>
    </div>
</template>

<script>
    import {
        vIcon,
        vIconButton,
        vErrorMessages,
    } from '@/components/form';
    import vModal from '@/components/modal/v-modal';
    import TagsManagerModal from '@/components/tags-manager/tags-manager-modal';
    import {mapActions, mapState} from 'vuex';

    export default {
        name: 'customer-tags',
        components: {
            vIcon,
            vModal,
            vIconButton,
            vErrorMessages,
            TagsManagerModal,
        },
        data() {
            return {
                type: 'customer',
                isLoading: false,
                showTagsModal: false,
                asyncConfig: {},
            };
        },
        computed: {
            ...mapState('customers', ['customer']),
            tags() {
                return this.customer.tags.map(tag => tag.name);
            },
        },
        methods: {
            ...mapActions({
                fetchCustomer: 'customers/fetch',
                removeTag: 'customers/removeTag',
                updateTags: 'customers/updateTags',
            }),
            openTagsModal() {
                this.showTagsModal = true;
            },
            async removeCustomerTag(tag) {
                try {
                    await this.removeTag(tag);
                    this.$toast.positive('Tag removed');
                    await this.updateCustomerInfo();
                } catch (error) {
                    this.$toast.fromError(error);
                }
            },
            async updateCustomerTag({created, value}) {
                const added = value.filter(name => !created.includes(name));
                const deleted = this.tags.filter(name => !value.includes(name));
                try {
                    await this.updateTags({
                        created, deleted, added, value,
                    });
                    this.$toast.positive('Tags updated');
                    await this.updateCustomerInfo();
                } catch (error) {
                    this.$toast.fromError(error);
                } finally {
                    this.showTagsModal = false;
                }
            },
            async updateCustomerInfo() {
                const customerParams = {
                    id: this.customer.id,
                    expand: 'leadSource,defaultPaymentInstrument',
                };
                await this.fetchCustomer({params: customerParams});
            },
            async asyncFind(search, query = {}) {
                const {items} = await this.$api(({tags}) => tags.getAll({...query, q: search}));
                return items
                    .reduce((memo, tag) => ({...memo, [tag.fields.name]: tag.fields.name}), {});
            },
            async asyncGetInitValue(names) {
                const {items} = await this.$api(({tags}) => tags.getAll({filter: `name:${names}`}));
                return items
                    .reduce((memo, tag) => ({...memo, [tag.fields.name]: tag.fields.name}), {});
            },
        },
    };
</script>
